import { Result } from 'src/types/result';

interface ExecutionData {
  result: Result;
  errorInfo?: {
    errorCode: string;
    errorDescription: string;
  };
  output?: {
    tenant?: {
      resourceId: string;
    };
  };
}

// Global state shared across all hook instances
let predefinedExecutionData: ExecutionData | null = null;

export const getGlobalExecutionState = (): {
  predefinedExecutionData: ExecutionData | null;
} => ({
  predefinedExecutionData
});

export const setGlobalPredefinedExecutionData = (
  data: ExecutionData | null
): void => {
  predefinedExecutionData = data;
};

export const resetGlobalExecutionState = (): void => {
  predefinedExecutionData = null;
};
